import { render } from "./HomePage.vue?vue&type=template&id=555cd3da"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zonk/dev/projects/zoom_video_sdk_vue3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__